<al-layout-options [applyContentPadding]="true"></al-layout-options>
<al-navigation-frame>
    <main class="content">
        <router-outlet></router-outlet>
    </main>
</al-navigation-frame>
